import React from 'react';
import { Row, Col } from 'antd';
import withUnAuth from './withUnAuth';
import SignInForm from '../Forms/Auth/SignIn';
import AuthContainer from '../../modules/auth/containers/Auth';

const SignInPage = ({ doSignIn }) => {
  return (
    <div className="SignInPage">
      <Row>
        <Col xs={0} sm={0} md={{ span: 12 }}>
          <div
            className="LeftImg"
            style={{
              backgroundImage: `url('/forward.png')`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              height: '100%', // Ensure it takes full height
              width: '100%', // Ensure it takes full width
            }}
          />
        </Col>
        <Col xs={24} sm={24} md={{ span: 12 }}>
          <SignInForm doSignIn={doSignIn} />
        </Col>
      </Row>
    </div>
  );
};

export default withUnAuth(AuthContainer(SignInPage));
